import {AbstractEvent} from "@/modules/base/events";
import {Matchday} from "@/modules/competitions/entity";

export class BeforeMatchdayEvaluation extends AbstractEvent {
  constructor(
    public matchday: Matchday
  ) {
    super();
  }
}